<mat-card-title>
    Submit Help Request
</mat-card-title>
<mat-card-content style="min-width: 40vw; display: block;">
    <div class="row">
      <employee-search label="Assigned User"
        ngModel
        (ngModelChange)="assignedUserId = $event.userId"
      ></employee-search>
    </div>
    <div class="row">
        <mat-form-field class="w-100">
            <mat-label>Issue Description</mat-label>
            <textarea matInput placeholder="Please describe your issue..." [(ngModel)]="issueText" rows="4"></textarea>
        </mat-form-field>
    </div>
</mat-card-content>
<mat-card-actions class="d-flex justify-content-end w-100">
    <button mat-flat-button color="primary" [disabled]="!issueText || !assignedUserId" class="button-text" [matDialogClose]="[issueText, assignedUserId]">Submit</button>
    <button mat-flat-button [matDialogClose]="null" class="ml-2 button-text">Cancel</button>
</mat-card-actions>